export default {
    names: {
        hour: "час",
        minute: "минута",
        day: "день",
    },
    objects: {
        offline_update: "Отключить проверку обновлений",
        time: "Время",
        type_time: "Формат времени",
        button_save: "Сохранить",
        period: "Период проверки обновлений",
        address: "Адрес сервера для обновлений",
        setting: "Настройки"
    },
    notification: {
        incorrect_data: "Значение не должно быть 0",
        incorrect_time: "Значение должно быть больше 0",
        load_error: "Ошибка загрузки",
        download_ok: "Изменения сохранены",
        download_error: "Ошибка при сохранении",
    },
}